import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'embryo-SubscribeOne',
  templateUrl: './SubscribeOne.component.html',
  styleUrls: ['./SubscribeOne.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SubscribeOneComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
